import { API } from "aws-amplify";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { getProjectDetails } from "actions/projects";

export const GET_CUSTOMER_INTERVALS_DOWNLOAD_TEMPLATE_REQUEST =
  "@@customerIntervals/GET_CUSTOMER_INTERVALS_DOWNLOAD_TEMPLATE_REQUEST";
export const GET_CUSTOMER_INTERVALS_DOWNLOAD_TEMPLATE_SUCCESS =
  "@@customerIntervals/GET_CUSTOMER_INTERVALS_DOWNLOAD_TEMPLATE_SUCCESS";
export const GET_CUSTOMER_INTERVALS_DOWNLOAD_TEMPLATE_FAILURE =
  "@@customerIntervals/GET_CUSTOMER_INTERVALS_DOWNLOAD_TEMPLATE_FAILURE";

export function getCustomerIntervalsDownloadTemplate(
  id = "",
  organisation,
  sample_table = true
) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: GET_CUSTOMER_INTERVALS_DOWNLOAD_TEMPLATE_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=in_sample_intervals_new&organisation=${organisation}&sample_table=${sample_table}`;
      }

      const response = await API.get("usimAPI", url);

      dispatch({
        type: GET_CUSTOMER_INTERVALS_DOWNLOAD_TEMPLATE_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_CUSTOMER_INTERVALS_DOWNLOAD_TEMPLATE_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_CUSTOMER_INTERVALS_LIST_REQUEST =
  "@@customerIntervals/GET_CUSTOMER_INTERVALS_LIST_REQUEST";
export const GET_CUSTOMER_INTERVALS_LIST_SUCCESS =
  "@@customerIntervals/GET_CUSTOMER_INTERVALS_LIST_SUCCESS";
export const GET_CUSTOMER_INTERVALS_LIST_FAILURE =
  "@@customerIntervals/GET_CUSTOMER_INTERVALS_LIST_FAILURE";

export function getCustomerIntervalsList(id = "", organisation) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: GET_CUSTOMER_INTERVALS_LIST_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=in_sample_intervals_new&organisation=${organisation}&sample_table=false`;
      }

      const response = await API.get("usimAPI", url);
      dispatch({
        type: GET_CUSTOMER_INTERVALS_LIST_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_CUSTOMER_INTERVALS_LIST_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}

export const DELETE_CUSTOMER_INTERVALS_LIST_REQUEST =
  "@@customerIntervals/DELETE_CUSTOMER_INTERVALS_LIST_REQUEST";
export const DELETE_CUSTOMER_INTERVALS_LIST_SUCCESS =
  "@@customerIntervals/DELETE_CUSTOMER_INTERVALS_LIST_SUCCESS";
export const DELETE_CUSTOMER_INTERVALS_LIST_FAILURE =
  "@@customerIntervals/DELETE_CUSTOMER_INTERVALS_LIST_FAILURE";

export function deleteCustomerIntervalsList(id = "", organisation) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: DELETE_CUSTOMER_INTERVALS_LIST_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=in_sample_intervals_new&organisation=${organisation}`;
      }

      const response = await API.del("usimAPI", url);
      dispatch({
        type: DELETE_CUSTOMER_INTERVALS_LIST_SUCCESS,
        payload: response,
      });
      dispatch(getProjectDetails(id));
    } catch (error) {
      dispatch({
        type: DELETE_CUSTOMER_INTERVALS_LIST_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}

export const UPLOAD_CUSTOMER_INTERVALS_DATA_REQUEST =
  "@@customerIntervals/UPLOAD_CUSTOMER_INTERVALS_DATA_REQUEST";
export const UPLOAD_CUSTOMER_INTERVALS_DATA_SUCCESS =
  "@@customerIntervals/UPLOAD_CUSTOMER_INTERVALS_DATA_SUCCESS";
export const UPLOAD_CUSTOMER_INTERVALS_DATA_FAILURE =
  "@@customerIntervals/UPLOAD_CUSTOMER_INTERVALS_DATA_FAILURE";

export function uploadCustomerIntervalsData(
  id = "",
  organisation,
  file,
  columnMappings,
  callback
) {
  return async (dispatch) => {
    if (!id) return;
    dispatch({
      type: UPLOAD_CUSTOMER_INTERVALS_DATA_REQUEST,
    });
    try {
      let url = "/presignedurl";
      if (id) {
        url = `${url}?project_id=${id}&table_name=in_sample_intervals_new`;
      }

      if (!isEmpty(columnMappings)) {
        url = `${url}&column_mappings=${encodeURI(
          JSON.stringify(columnMappings)
        )}`;
      }

      const response = await API.get("usimAPI", url);

      const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": "application/gzip" },
        body: file,
      };
      await fetch(response.uploadURL, requestOptions).then((response) => {
        if (response.status === 200) {
          toast.success("Data uploaded successfully!");
          setTimeout(() => {
            dispatch(getCustomerIntervalsList(id, organisation));
          }, 2000);
          callback({
            success: true,
          });
        } else {
          dispatch({
            type: UPLOAD_CUSTOMER_INTERVALS_DATA_FAILURE,
            payload: {
              message: "Upload data failed.",
            },
          });
        }
      });

      dispatch({
        type: UPLOAD_CUSTOMER_INTERVALS_DATA_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: UPLOAD_CUSTOMER_INTERVALS_DATA_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}

export const GET_CUSTOMER_INTERVALS_INPUTS_REQUIRED_REQUEST =
  "@@customerIntervals/GET_CUSTOMER_INTERVALS_INPUTS_REQUIRED_REQUEST";
export const GET_CUSTOMER_INTERVALS_INPUTS_REQUIRED_SUCCESS =
  "@@customerIntervals/GET_CUSTOMER_INTERVALS_INPUTS_REQUIRED_SUCCESS";
export const GET_CUSTOMER_INTERVALS_INPUTS_REQUIRED_FAILURE =
  "@@customerIntervals/GET_CUSTOMER_INTERVALS_INPUTS_REQUIRED_FAILURE";

export function getInputsRequired(id = "", organisation) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: GET_CUSTOMER_INTERVALS_INPUTS_REQUIRED_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=needed_customer_load_profiles&organisation=${organisation}`;
      }

      const response = await API.get("usimAPI", url);

      dispatch({
        type: GET_CUSTOMER_INTERVALS_INPUTS_REQUIRED_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_CUSTOMER_INTERVALS_INPUTS_REQUIRED_FAILURE,
        payload: error,
      });
    }
  };
}
